export default __webpack_public_path__ + "static/media/logo.a445d09f.png";